import { Card, CardContent, Container, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import FormSendEmail from 'src/Patient/recoveryPassword/components/FormSendEmail'
import FormPasswordTemporal from 'src/Patient/recoveryPassword/components/FormPasswordTemporal'
import { activeStepResetPasswordState, completedStepResetPasswordState } from 'src/Patient/recoveryPassword/state/atoms'
import FormResetPassword from 'src/Patient/recoveryPassword/components/FormResetPassword'
import { errorsFormRegisterState, rulesPasswordState, valuesFormRegisterState } from 'src/Patient/state/atoms'
import { showBannerState } from 'src/store/global/bannerShowState'
import { stepperRecoveryPasswordShowState } from 'src/store/global/steppersShowState'
import useSEO from 'src/Hooks/useSEO';

const ForgotPassword = () => {
    const activeStepResetPassword = useRecoilValue(activeStepResetPasswordState);

    const resetPatientInformation = useResetRecoilState(valuesFormRegisterState);
    const resetPatientErrors = useResetRecoilState(errorsFormRegisterState);
    const resetRulesPassword = useResetRecoilState(rulesPasswordState);
    const resetActiveStepResetPassword = useResetRecoilState(activeStepResetPasswordState);
    const resetCompletedStepResetPassword = useResetRecoilState(completedStepResetPasswordState);
    const setShowBanner = useSetRecoilState(showBannerState);
    const stepperRecoveryPasswordShow  = useSetRecoilState(stepperRecoveryPasswordShowState);
    
    useSEO({title: 'Recuperar contraseña'});
    
    useEffect(() => {
        setShowBanner(false);
        stepperRecoveryPasswordShow(true);
        return () => {
            setShowBanner(true);
            stepperRecoveryPasswordShow(false);
            resetPatientInformation();
            resetPatientErrors();
            resetRulesPassword();
            resetActiveStepResetPassword();
            resetCompletedStepResetPassword();
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container style={{ maxWidth: 600 }}>
            {/* <StepsResetPassword color={theme.palette.primary.main} /> */}
            <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
                RECUPERE SU CONTRASEÑA
            </Typography>
            <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
                INGRESE SUS DATOS
            </Typography>

            <Card>
                <CardContent>
                    { activeStepResetPassword === 0 && <FormSendEmail />}
                    { activeStepResetPassword === 1 && <FormPasswordTemporal />}
                    { activeStepResetPassword === 2 && <FormResetPassword />}
                </CardContent>
            </Card>
        </Container>
    )
}

export default ForgotPassword;